
export default {
  name: "PricingTabButtonsEx",
  data() {
    return {
      tabStep: 1,
    }
  },
  props: ['step'],
  methods: {
    change(tab) {
      this.$emit('change', tab);
    }
  }
}
